module.exports = __webpack_public_path__ + "img/typescript.645f760a.jpg";